var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-field"},[_vm._t("default",function(){return [_vm._v("Base Field")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }